const SohoFrameworkTestKeys = Object.seal({
  AddOnsDisplayChangeBtn: 'displayChangeBtn',
  AddOnsLoading: 'addOnsLoading',
  AddOnsError: 'addOnsError',
  AddOnsDataView: 'addOnsData',
  AddOnDetailsPrimaryBtn: 'addonDetailsPrimaryBtn',
  AddOnDetailsSecondaryBtn: 'addonDetailsSecondaryBtn',
  MyProfileRequestedAddOnsEmptyText: 'my_profile_requested_addon_empty_text_test_key',
  AddOnsActiveAddonsEmptyText: 'active_addon_empty_title',
  DevicesEmptyImage: 'empty_device_case_image',
  LicencesEmptyImage: 'empty_license_case_image',
  LicencesLoading: 'BOLicencesLoading',
  LicencesError: 'BOLicencesError',
  MarketplaceFavBtn: 'marketplace_favorite_btn',
  MarketplaceFavBtnIcon: 'marketplace_favorite_btn_icon',
  MarketplaceApplicationCard: 'marketplace_application_card',
  MarketplaceScrollView: 'MarketplaceScrollView',
  MarketplaceApplicationSectionSeeAllBtn: 'soho_marketplace_application_section_see_all_button',
  AppPDPSummaryLicenceCounterMinusBtn: 'counterMinusBtn',
  AppPDPSummaryLicenceCounterPlusBtn: 'counterPlusBtn',
  RequestsCardViewDetailsBtn: 'view_details_request_card_btn',
  RequestsCardMainSubtitle: 'requestCardMainSubtitle',
  RequestsCardMainSubtitleFirstPart: 'requestCardMainSubtitleFirstPart',
  RequestsCardMainSubtitleSecondPart: 'requestCardMainSubtitleSecondPart',
  RequestsCardPrimaryBtn: 'requestCardPrimaryBtn',
  RequestsFullScreenError: 'request_full_page_error_screen',
  RequestsTab: 'request_tab_',
  ErrorScreen: '_error_screen',
  RequestsEmptySearchResult: 'noResultText',
  UsersAndGroupsShowMoreBtn: 'soho_my_users_and_groups_show_more_btn',
  UsersAndGroupsShowLessBtn: 'soho_my_users_and_groups_show_less_btn',
  UsersAndGroupsEmptySearchResult: 'noResultText',
  UsersAndGroupsManageGroupView: 'manageGroupsView',
  SearchBarClearBtn: 'clearButton',
  SearchBarSearchBtn: 'searchButton',
  SelectionListSelectAllBtn: 'selectAllBtn',
  SelectionListShowLessBtn: 'showLessBtn',
  SelectionListShowMoreBtn: 'showMoreBtn',
  ItemCardName: ' card name',
  ConfirmationQuickActionTotalCostText: 'totalPriceTxt',
  DBUsageCardUnlimitedTxt: 'DBUsageCardUnlimitedTxt',
  DBUsageCardLeftOfTxt: 'DBUsageCardLeftOfTxt',
  DBUsageCardFooterTxtUnlimited: 'DBUsageCardFooterTxtUnlimited',
  DBUsageCardFooterTxt: 'DBUsageCardFooterTxt',
  DBUsageCardAddMoreBtn: 'DBUsageCardAddMoreBtn',
  BackIcon: 'backIcon',
  CloseIcon: 'closeIcon',
  PlanSectionTitle: 'planSectionTitle',
  PlanTitle: 'planTitle',
  ViewPlanActiveBtn: 'viewPlanActive',
  ViewPlanInactiveBtn: 'viewPlanInactive',
  NumberOfUsersInPlanTitle: 'numberOfUsersInPlanTitle',
  PlanProductTitle: 'planProductTitle',
  planUsageNote: 'planUsageNote',
  planProductUsageValue: 'planProductUsageValue',
  PlanProductUsageValue: 'planProductUsageValue',
  PlanProductUsagePercentage: 'planProductUsagePercentage',
  PlanPricePerMonthTitle: 'pricePerMonthTitle',
  PlanPriceValue: 'planPriceValue',
  PlanTitlePart: 'date',
  PlanSecondPartTitle: 'Title',
  PlanSecondPartValue: 'Value',
  PlanShowBtn: 'planShowBtn',
  PlanListDateTitle: 'listDateTitle',
  PlanListDateValue: 'listDateValue',
  PlanStatusTitle: 'planStatusTitle',
  PlanAddDataBtn: 'addData',
  PlanAddSMSBtn: 'addSMS',
  PlanAddCallBtn: 'addCall',
  PlanAddUsersBtn: 'PlanAddUsersBtn',
  PlanRemoveUserBtn: 'removeUserBtn',
  PlanUsersTitle: 'planUsersTitle',
  PlanViewProfileBtn: 'viewProfile',
  PlanUserNameTitle: 'userNameTitle',
  PlanNumberOfUsersInPlanTitle: 'numberOfUsersInPlanTitle',
  PlanCBUnassignedUser: 'cBUnassignedUser',
  PlanNumberOfUnAssignedUsersInPlanTitle: 'numberOfUnAssignedUsersInPlanTitle',
  PlanConfirmAddUsersBtn: 'confirmAddUsers',
  ConfirmationQuickActionConfirmBtn: 'overlayConfirmation',
  ConfirmationQuickActionCancelBtn: 'overlayCancel',
  QuickActionMainTitle: 'quickActionMainTitle',
  ConfirmationQuickAction: 'overlayText',
  SelectionListRemoveIcon: 'removeIcon',
  ResultModalSuccessfulDescription: 'successfulSubTitle',
  ResultModalSuccessfulSubTitle: 'successfulDescriptionTitle',
  ResultModalSuccessfulTitle: 'successfulTitle',
  ResultModalSuccessfulPrimaryBtn: 'primary',
  ResultModalSuccessfulSecondaryButton: 'secondary',
  LottieViewTestID: 'imgTick',
  ManageGroupUsersWithinGroupSelectionList: 'manageGroupUsersWithinGroupSelectionList',
  ManageGroupUsersOutsideGroupSelectionList: 'manageGroupUsersOutsideGroupSelectionList',
  LicencesUsageTitleText: 'licencesUsageTitleText',
  DevicesHeaderTitleText: 'devicesHeaderTitleText',
  PlanTitleContainer: 'planTitleContainer',
  UsageTitleContainer: 'usageTitleContainer',
});
export default SohoFrameworkTestKeys;
